import React from 'react';
import { cn } from '../../lib/utils';
import { MenuCategory } from '../../lib/types';
import { motion, AnimatePresence } from 'framer-motion';
interface ParentCategory {
  key: string;
  label: string;
  icon: string;
}
interface MenuParentTabsProps {
  parents: ParentCategory[];
  activeParent: string;
  onSelectParent: (parentKey: string) => void;
  subcategories: MenuCategory[];
  activeSubcategory: string;
  onSelectSubcategory: (categoryId: string) => void;
  primaryColor?: string;
}
export function MenuParentTabs({
  parents,
  activeParent,
  onSelectParent,
  subcategories,
  activeSubcategory,
  onSelectSubcategory,
  primaryColor = '#F59E0B'
}: MenuParentTabsProps) {
  if (!parents.length) return null;
  return <div className="sticky top-0 z-30 w-full bg-[#0B0B0B]/95 backdrop-blur-md border-b border-white/[0.04] py-3 -mx-4 px-4 sm:-mx-6 sm:px-6" data-id="element-1179">
      {/* Level 1: Parent Tabs — minimal text links */}
      <div className="flex gap-6 mb-3" data-id="element-1180">
        {parents.map(parent => {
        const isActive = activeParent === parent.key;
        return <button key={parent.key} onClick={() => onSelectParent(parent.key)} className={cn('relative pb-2 text-sm font-semibold transition-colors whitespace-nowrap', isActive ? 'text-white' : 'text-white/30 hover:text-white/50')} data-id="element-1181">
              {parent.label}
              {isActive && <motion.div layoutId="activeParentIndicator" className="absolute bottom-0 left-0 right-0 h-[2px] rounded-full" style={{
            backgroundColor: primaryColor
          }} initial={false} transition={{
            type: 'spring',
            stiffness: 500,
            damping: 35
          }} data-id="element-1182" />}
            </button>;
      })}
      </div>

      {/* Level 2: Subcategory Chips — subtle pills (hidden when only 1 subcategory) */}
      <AnimatePresence mode="wait" data-id="element-1183">
        {subcategories.length > 1 && <motion.div key={activeParent} initial={{
        opacity: 0,
        y: 4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -4
      }} transition={{
        duration: 0.15
      }} className="flex overflow-x-auto hide-scrollbar" data-id="element-1184">
            <div className="flex gap-2 min-w-max" data-id="element-1185">
              {subcategories.map(category => {
            const isActive = activeSubcategory === category.id;
            return <button key={category.id} onClick={() => onSelectSubcategory(category.id)} className={cn('px-3.5 py-1.5 text-xs font-medium rounded-full transition-all whitespace-nowrap', isActive ? 'text-white' : 'text-white/35 hover:text-white/55 bg-transparent')} style={isActive ? {
              backgroundColor: `${primaryColor}20`,
              color: primaryColor
            } : {}} data-id="element-1186">
                    {category.name}
                  </button>;
          })}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}